module.exports = __webpack_public_path__ + "imgs/website-white.6401288daabb600018fd2432dbf5b961.svg";